import { Box } from '@chakra-ui/react';

export const Divider = ({ color = 'gray.200' }: { color?: string }) => {
  return <Box h="1px" bg={color} my={2} w="100%" mx="auto" />;
};
